
const LocationSection = () => {
  return (
    <section className="py-20 bg-sand-beige">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <p className="text-nature-green text-sm font-semibold uppercase tracking-wider mb-3">
              Localização
            </p>
            <h2 className="text-4xl md:text-5xl font-light text-navy-blue mb-6">
              Em Machico, <span className="font-serif italic">Madeira</span>
            </h2>
            <p className="text-gray-600 text-lg leading-relaxed mb-6">
              Os nossos apartamentos estão situados em Machico, junto à Levada do Caniçal, 
              com vistas deslumbrantes para o mar e para a montanha. Um refúgio perfeito 
              entre a natureza e o oceano Atlântico.
            </p>

            <div className="space-y-4 mb-8">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-sea-blue/10 flex-shrink-0">
                  <i className="ri-map-pin-line text-sea-blue text-xl"></i>
                </div>
                <div>
                  <h4 className="font-bold text-navy-blue mb-1">Machico, Madeira</h4>
                  <p className="text-gray-600 text-sm">Junto à Levada do Caniçal, numa zona tranquila e privilegiada</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-sea-blue/10 flex-shrink-0">
                  <i className="ri-water-flash-line text-sea-blue text-xl"></i>
                </div>
                <div>
                  <h4 className="font-bold text-navy-blue mb-1">Vista Mar e Montanha</h4>
                  <p className="text-gray-600 text-sm">Vistas deslumbrantes sobre o Atlântico e as serras da Madeira</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-sea-blue/10 flex-shrink-0">
                  <i className="ri-walk-line text-sea-blue text-xl"></i>
                </div>
                <div>
                  <h4 className="font-bold text-navy-blue mb-1">Levada do Caniçal</h4>
                  <p className="text-gray-600 text-sm">Acesso direto a uma das levadas mais bonitas da ilha</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-sea-blue/10 flex-shrink-0">
                  <i className="ri-flight-takeoff-line text-sea-blue text-xl"></i>
                </div>
                <div>
                  <h4 className="font-bold text-navy-blue mb-1">Aeroporto</h4>
                  <p className="text-gray-600 text-sm">A apenas 10 minutos do Aeroporto Internacional da Madeira</p>
                </div>
              </div>
            </div>

            <a
              href="https://maps.app.goo.gl/XWJGnzA1wZStY3Fa8"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-6 py-3 bg-sea-blue text-white rounded-full font-semibold hover:bg-sea-blue/90 transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-map-2-line text-xl"></i>
              Abrir no Google Maps
            </a>
          </div>

          <div className="relative h-[500px] rounded-3xl overflow-hidden shadow-2xl">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3000!2d-16.781175!3d32.742384!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzLCsDQ0JzMyLjYiTiAxNsKwNDYnNTIuMiJX!5e0!3m2!1spt-PT!2spt!4v1234567890"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Localização Seaview & Levada Escape - Machico, Madeira"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocationSection;
